<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
              <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="12">
              <h3>Add a New Campaign</h3>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span> Campaign Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="campaign_name" v-model="campaigns.campaign_name" v-validate="'required'"
                data-vv-as="Campaign Name" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('campaign_name')">{{
              errors.first("campaign_name")
              }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Campaign Code:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input class="w-full" name="campaign_code" v-model="campaigns.campaign_code" v-validate="'required'"
                data-vv-as="Campaign Code" @change="CheckUniqueCampaignCode" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('campaign_code')">{{
              errors.first("campaign_code")
              }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Campaign Manager:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <CampaignManagerAutocomplete :key="companySearchComponentKey" class="searchbox"
                :list="searchCampaignManager" :searchOn="'search_campaign_manager'" @event-name="handleCampaignManager">
              </CampaignManagerAutocomplete>
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('campaign_manager')">{{
              errors.first("campaign_manager")
              }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Start Date:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <datepicker v-validate="'required'" data-vv-as="Start Date" :language="$vs.rtl ? langHe : langEn"
                name="start_date" v-model="campaigns.start_date" :disabledDates="disabledStartDates"></datepicker>
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('start_date')">{{ errors.first("start_date")
              }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>End Date:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <datepicker v-validate="'required'" data-vv-as="End Date" :language="$vs.rtl ? langHe : langEn"
                name="end_date" v-model="campaigns.end_date" :disabledDates="disabledEndDates"></datepicker>
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('end_date')">{{ errors.first("end_date")
              }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Setup:</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">

              <v-select label="po_number" name="setup_purchase_order_id" :options="PurchaseOrderList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="campaigns.setup_purchase_order_id" />

            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input @input="onSetupInput" type="number" class="w-full" name="setup" v-model="campaigns.setup"
                data-vv-as="Setup" />

            </div>

          </div>




          <vs-divider class="m-5" />

          <div class="">
            <template v-for="(purchase_order, ind) in campaigns.purchase_orders">

              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>PO Number:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                 

                  <POAutocomplete :key="'po_' + ind" class="searchbox" 
    :list="searchPO" :searchOn="'search_po'"
    @event-name="handleSelectedPO(ind)">
</POAutocomplete>


                </div>
                <vs-icon v-if="ind > 0" class="ml-10 removeButton" @click="removePurchaseOrder(ind)" color="success"
                  icon="clear"></vs-icon>
              </div>




              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>PO Value Allocated to Campaign:</span>
                </div>



                <div class="vx-col sm:w-1/6 w-full">
                  <vs-input type="number" class="w-full" v-model="campaigns.purchase_orders[ind]['allocated_value']"
                    name="allocated_value" @input="onAllocationInput(ind)" />

                </div>
                {{ purchase_order.remaining_po_value ? 'Available :' + purchase_order.remaining_po_value : null }}
              </div>
            </template>
          </div>

          <div class="text-center mb-5">
            <vs-button color="primary" @click="addPurchaseOrders" type="filled">Add PO</vs-button>
          </div>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Daily Rate:</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input type="number" class="w-full" name="daily_rate" v-model="campaigns.daily_rate"
                v-validate="'required'" data-vv-as="Daily Rate" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('daily_rate')">{{ errors.first("daily_rate")
              }}</span>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Target Pipeline:</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input type="number" class="w-full" name="target_pipeline" v-model="campaigns.target_pipeline"
                v-validate="'required'" data-vv-as="Target Pipeline" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('target_pipeline')">{{
              errors.first("target_pipeline")
              }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Target Number of Opportunities:</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input type="number" class="w-full" name="target_no_of_opportunities"
                v-model="campaigns.target_no_of_opportunities" v-validate="'required'"
                data-vv-as="Target Number of Opportunities" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('target_no_of_opportunities')">{{
              errors.first("target_no_of_opportunities")
              }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Target Number of VACs:</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input type="number" class="w-full" name="target_no_of_vacs" v-model="campaigns.target_no_of_vacs"
                v-validate="'required'" data-vv-as="Target Number of VACs" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('target_no_of_vacs')">{{
              errors.first("target_no_of_vacs")
              }}</span>
          </div>


          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>No Sales Developer required:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-checkbox v-model="campaigns.noSdRequired" @change="onNoSdRequiredToggle"></vs-checkbox>
            </div>
          </div>

          <div class="" v-if="!campaigns.noSdRequired">
            <template v-for="(sales,
              index) in campaigns.sales_developers">
              <div class="vx-row" :key="'sd_row_' + sales.counter">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Sales Developer {{ index + 1 }}:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">

                  <v-select class="new_select_class" v-model="sales.name" :options="allSalesDevelopers" /><br>

                </div>
                <vs-icon :key="'sd_icon_' + sales.counter" class="ml-10 removeButton"
                  @click="removeSelectedSalesDeveloper(sales)" color="success" icon="clear"></vs-icon>
              </div>
            </template>

            <SdAllocationPanel v-if="!campaigns.allocationExempt" :sales-developers="campaigns.sales_developers" :option-list="allSalesDevelopers"
              :start-date="campaigns.start_date" :end-date="campaigns.end_date" :campaign-id="null"
              :budget-days="sdBudgetDays" :edit-mode="false" row-name-key="name" @change="onSdAllocationChange" />
          </div>
          <div class="text-center m-5" v-if="!campaigns.noSdRequired">
            <span class="text-danger text-sm mt-2 mr-10" v-show="errors.has('sales_developer')">{{
              errors.first("sales_developer")
              }}</span>
            <vs-button color="primary" @click="addSalesDeveloper" type="filled">Add Sales Developer</vs-button>
          </div>
           <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/5 w-full">
            <span>Internal campaign (SD time not allocated):</span>
          </div>
          <div class="vx-col sm:w-1/3 w-full">
            <vs-checkbox v-model="campaigns.allocationExempt"></vs-checkbox>
          </div>
        </div>
          <!-- <div class="">
            <template v-for="(sales,
                index) in campaigns.sales_developers">
                <div  class="vx-row" :key="index">
                  <div class="vx-col sm:w-1/5 w-full">
                  <span>Sales Developer {{ index + 1 }}:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">

                  <v-select class="new_select_class"  v-model="sales.name" :options="allSalesDevelopers" /><br>
                </div>
                <vs-icon :key="index" class="ml-10 removeButton"
                  @click="removeSelectedSalesDeveloper(sales)" color="success" icon="clear"></vs-icon>
              </div>
            </template>
          </div>
          <div class="text-center m-5">
            <span class="text-danger text-sm mt-2 mr-10" v-show="errors.has('sales_developer')">{{
              errors.first("sales_developer")
            }}</span>
            <vs-button color="primary" @click="addSalesDeveloper" type="filled">Add Sales Developer</vs-button>
          </div> -->
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Campaign Status:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <v-select v-validate="'required'" required label="campaign_status" name="campaign_status"
                :options="campaignStatusList" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="campaigns.selected_campaign_status" data-vv-as="Campaign Status" />
            </div>
            <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('campaign_status')">{{
              errors.first("campaign_status")
              }}</span>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Briefing Document:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input @change="uploadBriefingDocument" ref="briefing_document" type="file" class="w-full"
                name="briefing_document" v-model="briefing_document" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>End Of Campaign Report:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input @change="uploadEndOfCampaignReport" ref="end_of_campaign_report" type="file" class="w-full"
                name="end_of_campaign_report" v-model="end_of_campaign_report" />
            </div>
          </div>
         

          <vs-divider class="m-5" />

          <div class="">
            <template v-for="(client, index) in campaigns.clients">

              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Primary Client:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <vs-radio v-model="campaigns.primary_client" :vs-value="String(client.client_id)"></vs-radio>
                </div>
              </div>

              <div class="vx-row mb-6" :key="'client_row_' + client.counter">


                <div class="vx-col sm:w-1/5 w-full">
                  <span>Client:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <ClientAutocomplete :key="companySearchComponentKey" class="searchbox" :list="searchClient"
                    :searchOn="'searched_clients'" @event-name="handleClientEvent(index)"></ClientAutocomplete>
                </div>
                <vs-icon :key="index" v-if="index > 0" class="ml-10 removeButton" @click="removeSelectedClient(client)"
                  color="success" icon="clear"></vs-icon>
              </div>
              <div class="vx-row mb-6" :key="'client_contact_' + client.counter">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Primary Client Contact:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <PrimaryContactAutocomplete :key="companySearchPrimaryContactComponentKey" class="searchbox"
                    :list="getPrimaryContacts" :searchOn="'search_primary_contacts'"
                    @event-name="handlePrimaryContacts(index)"></PrimaryContactAutocomplete>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Other Client Contact:</span>
                </div>
                <div class="vx-col sm:w-1/5 w-full">
                  <vs-button color="primary" @click="addOtherClientContact(client, index)" type="filled">Add Client
                    Contact</vs-button>
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                  <template v-for="otn in client.other_contact_name">
                    <span>{{ otn.first_name }} {{ otn.surname }}</span>
                    <br>
                  </template>
                  <vs-divider class="p-2" />


                </div>

              </div>
            </template>
            <div class="text-center mb-5">
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('client')">{{ errors.first("client")
                }}</span>
            </div>
          </div>

          <div class="text-center mb-5">
            <vs-button color="primary" @click="addClients" type="filled">Add Clients</vs-button>
          </div>
          <vs-divider class="m-5" />
          <div class="">
            <template v-for="(elomark_user,
              index) in campaigns.user_campaign_association">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                  <span>Privilege Elomark User:</span>
                </div>
                <div class="vx-col sm:w-1/3 w-full">
                  <ElomarkUserAutocomplete :key="companySearchComponentKey" class="searchbox" :list="searchElomarkUser"
                    :searchOn="'selected_elomark_user'" @event-name="handleElomarkUserEvent(index)">
                  </ElomarkUserAutocomplete>
                </div>
                <vs-icon :key="index" v-if="index > 0" class="ml-10 removeButton"
                  @click="removeSelectedElomarkUser(elomark_user)" color="success" icon="clear"></vs-icon>
              </div>
            </template>
            <div class="text-center mb-5">
              <span class="text-danger text-sm mt-2 ml-16" v-show="errors.has('privileged_elomark_user')">{{
                errors.first("privileged_elomark_user")
                }}</span>
            </div>
          </div>
          <div class="text-center">
            <vs-button color="primary" @click="addElomarkUser" type="filled">Add Elomark User</vs-button>
          </div>
          <vs-divider class="m-5" />



          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm">Submit</vs-button>
            </div>
          </div>
        </vx-card>
      </form>
    </div>
    <vs-popup fullscreen title="Choose Dashboard" :active.sync="listClientDashboardDataSetsPopup">
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span>Search :</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-input type="text" class="w-full" name="search_filter" v-model="search_filter" @keyup="updatePaginate" />
        </div>

      </div>
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span> </span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">

          <div class="vx-row mb-6 all_dashboard_rows"
            v-for="dashboard, index in filterBy(client_dashbashboard_lists, search_filter, 'name')"
            v-show="setPaginate(index)">
            <div class="vx-col w-full">
              <span>{{ dashboard.name }}</span>
              <vs-radio class="ml-10" v-model="selected_dashboard" :vs-value="dashboard"></vs-radio>
            </div>
          </div>
        </div>

      </div>
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span> </span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">

          <div class="pagination">
            <a href="#" class="btn btn-default" v-for="page_index in paginate_total"
              @click.prevent="updateCurrent(page_index + 1)">
              {{ page_index + 1 }}
            </a>
          </div>
        </div>

      </div>




      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full"></div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-button class="mr-3 mb-2" @click.prevent="submitDashboardSelection">Select Dashboard</vs-button>
        </div>
      </div>


    </vs-popup>
    <!-- <vs-popup fullscreen title="Dashboard User Permission" :active.sync="listClientDashboardDataSetsUserPermissionPopup">
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span>Search :</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-input type="text" class="w-full" name="search_filter" v-model="search_filter" @keyup="updatePaginate" />
        </div>

      </div>
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span> </span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">

          <div class="vx-row mb-6 all_dashboard_rows"
            v-for="dashboard, index in filterBy(client_dashbashboard_lists, search_filter, 'name')"
            v-show="setPaginate(index)">
            <div class="vx-col w-full">
              <span>{{ dashboard.name }}</span>
              <vs-radio class="ml-10" v-model="selected_dashboard" :vs-value="dashboard"></vs-radio>
            </div>
          </div>
        </div>

      </div>
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span> </span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">

          <div class="pagination">
            <a href="#" class="btn btn-default" v-for="page_index in paginate_total"
              @click.prevent="updateCurrent(page_index + 1)">
              {{ page_index + 1 }}
            </a>
          </div>
        </div>

      </div>




      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full"></div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-button class="mr-3 mb-2" @click.prevent="submitDashboardSelection">Select Dashboard</vs-button>
        </div>
      </div>


    </vs-popup> -->
    <vs-popup title="Add Client Contact" :active.sync="showClientContactPopup">

      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span>Search :</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-input type="text" class="w-full" name="search_filter" v-model="search_filter" @keyup="updatePaginate" />

          <!-- <PrimaryContactAutocomplete :key="companySearchComponentKey" class="searchbox"
                    :list="getPrimaryContacts" :searchOn="'search_primary_contacts'"
                    @event-name="handleOtheClientContacts(other_contact_id_index)"></PrimaryContactAutocomplete> -->

          <div class="vx-row mb-6 all_dashboard_rows mt-5"
            v-for="all_contact, index in filterBy(all_client_contact, search_filter, 'first_name', 'surname')"
            v-show="setPaginate(index)">
            <div class="vx-col sm:w-1/2 w-full">
              {{ all_contact.first_name }} {{ all_contact.surname }}

            </div>




            <div class="vx-col sm:w-1/4 w-full">
              <input type="checkbox" v-model="selected_client_contact" :value="all_contact" />
              <!-- <vs-checkbox v-model="selected_client_contact" :vs-value="all_contact"></vs-checkbox> -->

            </div>



          </div>


        </div>

      </div>
      <div class="vx-row mb-8">
        <div class="vx-col sm:w-1/6 w-full">
          <span> </span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">

          <div class="pagination">
            <a href="#" class="btn btn-default" v-for="page_index in paginate_total"
              @click.prevent="updateCurrent(page_index + 1)">
              {{ page_index + 1 }}
            </a>
          </div>
        </div>

      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full"></div>
        <div class="vx-col sm:w-1/2 w-full">
          <vs-button class="mr-3 mb-2" @click.prevent="selectOtherClientContact">Select</vs-button>
        </div>
      </div>


    </vs-popup>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from '@/config/abilities'
import Vue2Filters from 'vue2-filters'
import axios from "@/axios.js";
import POAutocomplete from "@/components/autocomplete/POAutocomplete.vue";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import CampaignManagerAutocomplete from "@/components/autocomplete/CampaignManagerAutocomplete.vue";
import SalesDeveloperAutocomplete from "@/components/autocomplete/SalesDeveloperAutocomplete.vue";
import PrimaryContactAutocomplete from "@/components/autocomplete/PrimaryContactAutocomplete.vue";
import ElomarkUserAutocomplete from "@/components/autocomplete/ElomarkUserAutocomplete.vue";
import moduleClientManagement from "@/store/clients-management/moduleClientsManagement.js";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import moduleClientUserManagement from "@/store/client-user-management/moduleClientUserManagement.js";
import modulePurchaseOrdersManagement from "@/store/campaign-management/purchase-orders-management/modulePurchaseOrdersManagement.js";
import Datepicker from "vuejs-datepicker";
import { en, he } from "vuejs-datepicker/src/locale";
import vSelect from "vue-select";
import moment from "moment";
import currency from "currency.js"
import a from 'file-saver';
import SdAllocationPanel from "./SdAllocationPanel.vue";
export default {
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      allSalesDevelopers: [],
      sdAllocationState: { allocations: [], allocatedDays: 0, hasBlocked: false, valid: true },
      selected_sales_developer: [],
      temp_setup_purchase_order_id: null,
      selected_po_numbers: [],
      POsearchComponentKey: 0,
      selected_available_po_value: 0,
      companySearchPrimaryContactComponentKey: 0,
      selected_client_contact: [],
      all_client_contact: [],
      other_contact_id_index: null,
      showClientContactPopup: false,
      current: 1,
      paginate: 20,
      paginate_total: 0,
      search_filter: '',
      selected_dashboard: null,
      listClientDashboardDataSetsPopup: false,
      listClientDashboardDataSetsUserPermissionPopup: false,
      client_access_token: null,
      client_dashbashboard_lists: [],
      abilities: null,
      briefing_document: "",
      end_of_campaign_report: "",
      campaignManagers: [],
      salesDevelopers: [],
      primaryClientContacts: [],
      campaignStatusList: [],
      PurchaseOrderList: [],
      companySearchComponentKey: 0,
      langHe: he,
      langEn: en,
      disabledStartDates: {
        to: new Date(Date.now() - 8640000)
      },
      disabledEndDates: {
        to: new Date(Date.now() - 8640000)
      },
      campaigns: {
        setup_purchase_order_id: null,
        campaign_po_and_po_allocated_value: [],
        noSdRequired: false,
        allocationExempt: false,
        alert_opportunity_owner: false,
        primary_client: null,
        main_purchase_order_counter: 0,
        main_client_counter: 0,
        main_elomark_user_counter: 0,
        main_sales_developer_counter: 0,
        main_client_dashboard_counter: 0,
        clients: [
          {
            counter: 0,
            client_id: null,
            primary_contact_id: null,
            other_contact_id: [],
            other_contact_name: [],
          }
        ],
        purchase_orders: [
          {
            counter: 0,
            po_id: null,
            remaining_po_value: 0,
          }
        ],
        user_campaign_association: [
          {
            counter: 0,
            id: null,
            name: null
          }
        ],
        sales_developers: [
          {
            counter: 0,
            name: null
          }
        ],
        selected_client_dashbashboards: [
          {
            counter: 0,
            id: null,
            name: null
          }
        ],
        campaign_name: null,
        campaign_code: null,
        client_id: null,
        campaign_manager: null,
        primary_client_contact: null,
        start_date: null,
        end_date: null,
        setup: null,
        target_pipeline: null,
        po_number: [],
        daily_rate: null,
        target_no_of_opportunities: null,
        target_no_of_vacs: null,
        campaign_status: null,
        selected_campaign_status: null,
        briefing_document: null,
        end_of_campaign_report: null,
        selected_campaign_manager: null,
        selected_clients: [],
        selected_primary_client_contact: [],
      }
    };
  },
  computed: {
    // D2: campaign day budget = Σ PO value allocated ÷ daily rate
    sdBudgetDays() {
      let rate = parseFloat(this.campaigns.daily_rate);
      if (isNaN(rate) || rate <= 0) return null;
      let total = 0;
      this.campaigns.purchase_orders.forEach(function (po) {
        let v = parseFloat(po.allocated_value);
        if (!isNaN(v)) total += v;
      });
      return total / rate;
    }
  },
  watch: {
    "campaigns.start_date": function (val) {
      this.disabledEndDates = {
        // to: new Date(Date.parse(val) + 86400)
        to: new Date(Date.parse(val))
      };
    },
    "campaigns.setup": function (val) {
      let self = this
      self.campaigns.setup_purchase_order_id = null
      self.campaigns.setup_purchase_order_id = self.temp_setup_purchase_order_id

    },
    "campaigns.setup_purchase_order_id": function (val) {
      let self = this
      this.temp_setup_purchase_order_id = val
      this.campaigns.purchase_orders.forEach(function (ele) {

        if (ele.hasOwnProperty('po_id')) {

          if (ele.po_id == val.id) {

            self.PurchaseOrderList.forEach(function (e) {
              if (ele.po_id == e.id) {

                ele.allocated_value = 0
                ele.remaining_po_value = parseFloat(e.remaining_po_value) - parseFloat(self.campaigns.setup)

              }

            })


          } else {


            self.PurchaseOrderList.forEach(function (e) {

              if (ele.po_id == e.id) {

                ele.allocated_value = 0
                ele.remaining_po_value = parseFloat(e.remaining_po_value)

              }


            })


          }
        }


        if (ele.remaining_po_value < 0) {
          self.$vs.dialog({
            accept: self.acceptAlert,
            color: "primary",
            title: `Purchase Order`,
            text:
              "There are not enough funds available on this PO.  Please either reduced the funds allocated to other campaigns OR select a different PO to allocate funds from.",
          });
          ele.remaining_po_value = parseFloat(val.remaining_po_value)
        }

      })





      // console.log(this.campaigns.purchase_orders)
    },
  },
  components: {
    "v-select": vSelect,
    moduleCampaignManagement,
    ClientAutocomplete,
    Datepicker,
    moduleElomarkUserManagement,
    moduleClientUserManagement,
    CampaignManagerAutocomplete,
    SalesDeveloperAutocomplete,
    PrimaryContactAutocomplete,
    ElomarkUserAutocomplete,
    POAutocomplete,
    SdAllocationPanel
  },
  created() {
    var self = this
    defineAbilitiesFor().then(function (data) {
      self.abilities = data
    });
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientsManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }

    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }
    if (!moduleClientUserManagement.isRegistered) {
      this.$store.registerModule(
        "clientUsersManagement",
        moduleClientUserManagement
      );
      moduleClientUserManagement.isRegistered = true;
    }

    if (!modulePurchaseOrdersManagement.isRegistered) {
      this.$store.registerModule(
        "PurchaseOrdersManagement",
        modulePurchaseOrdersManagement
      );
      modulePurchaseOrdersManagement.isRegistered = true;
    }



  },
  mounted() {
    this.getAllSalesDeveloper()
    this.getPurchaseOrderList();
    this.getCampaignStatus();

  },
  methods: {
    onSetupInput() {
      const setup = parseFloat(this.campaigns.setup);
      if (isNaN(setup)) return;
      if (setup < 0) { this.campaigns.setup = 0; return; }
      const setupPo = this.campaigns.setup_purchase_order_id;   // v-select object
      if (!setupPo || !setupPo.id) {
        this.$vs.notify({
          color: 'warning', title: 'Select the Setup PO first',
          text: 'Choose the Setup Purchase Order (next to the Setup box) before entering a setup fee.',
        });
        return;
      }
      const available = parseFloat(setupPo.remaining_po_value);
      if (!isNaN(available) && setup > available) {
        this.campaigns.setup = available;
        this.$vs.notify({
          color: 'warning', title: 'Setup fee capped',
          text: `Only ${available} is available on PO ${setupPo.po_number || ''} — the setup fee was reduced.`,
        });
      }
    },
    onAllocationInput(ind) {
      const row = this.campaigns.purchase_orders[ind];
      const entered = parseFloat(row.allocated_value);
      const available = parseFloat(row.remaining_po_value);
      if (isNaN(entered)) return;
      if (entered < 0) { row.allocated_value = 0; return; }
      if (!isNaN(available) && entered > available) {
        row.allocated_value = available;          // same clamp as before
        this.$vs.notify({
          color: 'warning', title: 'Allocation capped',
          text: `Only ${available} is available on this PO — the value was reduced.`,
        });
      }
    },
    onNoSdRequiredToggle() {
      // Option C (SDA CHANGE 02): the tick is refused while any SD is assigned.
      // Unticking is always allowed.
      if (!this.campaigns.noSdRequired) return;
      var hasSds = (this.campaigns.sales_developers || []).some(function (row) {

        return !!(row && (row.full_name || row.name));
      });
      if (!hasSds) return;
      var self = this;
      this.$nextTick(function () {
        self.campaigns.noSdRequired = false;
      });
      this.$vs.notify({
        color: "warning",
        title: "Sales Developers still assigned",
        text: "This campaign has Sales Developers assigned. Remove them (the X beside each row) before ticking \"No Sales Developer required\".",
        time: 8000
      });
    },
    acceptAlert() {
      this.campaigns.setup = 0;
    },
    selectOtherClientContact() {
      this.campaigns.clients[this.other_contact_id_index].other_contact_id = this.selected_client_contact
      this.campaigns.clients[this.other_contact_id_index].other_contact_name = this.selected_client_contact
      this.showClientContactPopup = false
    },
    addOtherClientContact(client, index) {
      this.other_contact_id_index = index
      if (client.client_id) {
        this.showClientContactPopup = true
        this.getAllClientContacts(client.client_id, index)
      }


    },
    submitDashboardSelection() {

      // selected_client_dashbashboards
      // console.log(this.selected_dashboard)
      this.listClientDashboardDataSetsPopup = false
      this.campaigns.selected_client_dashbashboards.push({
        counter: ++this.campaigns.main_client_dashboard_counter,
        id: this.selected_dashboard.id,
        name: this.selected_dashboard.name
      });

    },
    setPaginate: function (i) {
      if (this.current == 1) {
        return i < this.paginate;
      }
      else {
        return (i >= (this.paginate * (this.current - 1)) && i < (this.current * this.paginate));
      }
    },
    updateCurrent: function (i) {
      this.current = i;
    },
    updatePaginate: function () {
      this.current = 1;
      this.paginate_total = Math.ceil(document.querySelectorAll(".all_dashboard_rows").length / this.paginate);
    },
    updateCampaignDashboard(inputValue) {
      let data = {};
      data.access_token = this.client_access_token;
      data.search = inputValue;
      return this.$store
        .dispatch("campaignsManagement/updateCampaignDashboard", data)
        .then(res => {
          let result = res.data;

          result = result.filter(ele => ele.po_allocation != 'Fully Allocated')




          if (result) {
            result = result.value
            let mappedArray = [];
            for (const property in result) {
              mappedArray.push({
                id: result[property].id,
                name: result[property].name
              });
            }
            return mappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    removeSelectedClient(client) {
      this.campaigns.clients = this.campaigns.clients.filter(item => {
        return item.counter != client.counter;
      });
    },
    removePurchaseOrder(po) {
      console.log(this.campaigns.purchase_orders)
      this.campaigns.purchase_orders = this.campaigns.purchase_orders.filter(item => {
        return item.counter != po;
      });
    },
    removeSelectedElomarkUser(user) {
      this.campaigns.user_campaign_association = this.campaigns.user_campaign_association.filter(
        item => {
          return item.counter != user.counter;
        }
      );
    },
    removeSelectedSalesDeveloper(user) {
      this.campaigns.sales_developers = this.campaigns.sales_developers.filter(
        item => {
          return item.counter != user.counter;
        }
      );
    },
    addClients() {
      this.campaigns.clients.push({
        counter: ++this.campaigns.main_client_counter,
        client_id: null,
        primary_contact_id: null,
        other_contact_id: [],
        other_contact_name: [],
      });
    },
    addPurchaseOrders() {
      this.campaigns.purchase_orders.push({
        counter: ++this.campaigns.main_purchase_order_counter,
        po_id: null,
        remaining_po_value: null,
      });
    },
    addElomarkUser() {
      this.campaigns.user_campaign_association.push({
        counter: ++this.campaigns.main_elomark_user_counter,
        id: null,
        name: null
      });
    },
    addSalesDeveloper() {
      this.campaigns.sales_developers.push({
        counter: ++this.campaigns.main_sales_developer_counter,
        name: null

      });

    },
    onSdAllocationChange(state) {
      this.sdAllocationState = state;
    },
    searchElomarkUser(inputValue) {
      return this.$store
        .dispatch("elomarkUsersManagement/searchElomarkUser", inputValue)
        .then(response => {
          if (response) {

            let data = moduleElomarkUserManagement.state.elomark_user;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name: data[property].first_name + " " + data[property].surname
                });
              }
              var self = this
              const results = mappedArray.filter(({ id: id1 }) => !self.campaigns.user_campaign_association.some(({ id: id2 }) => id2 === id1));
              return results
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    CheckUniqueCampaignCode() {
      return this.$store
        .dispatch(
          "campaignsManagement/checkUniqueCampaignCode",
          this.campaigns.campaign_code
        )
        .then(response => {
          if (response) {
            if (response.data != null) {
              this.$vs.notify({
                color: "danger",
                title: "Duplicate Campaign Code",
                text: "Campaign Code Already exists. Please try another"
              });
              return;
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    uploadEndOfCampaignReport(e) {
      const files = e.target.files;
      const EOCRFile = files[0];
      if (!EOCRFile) return;
      if (
        EOCRFile.type != "application/pdf" &&
        EOCRFile.type != "text/plain" &&
        EOCRFile.type !=
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&
        EOCRFile.type !=
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        EOCRFile.type != "text/csv"
      ) {
        this.$vs.notify({
          color: "danger",
          title: "Invalid File",
          text:
            "The Briefing Document Must Be A File Of Type: Docx, Doc, Pdf, Xlsx, Xls, Csv, Txt."
        });
        return;
      }
      this.upload_file_name = EOCRFile.name;
      let axois_url =
        this.$base_url + "/api/campaigns/document_eocr_upload";
      let formData = new FormData();
      formData.append("file", EOCRFile);
      axios
        .post(axois_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status == "success") {
            this.campaigns.end_of_campaign_report = response.data.data;
          }
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    uploadBriefingDocument(e) {
      const files = e.target.files;
      const briefingFile = files[0];
      if (!briefingFile) return;
      if (
        briefingFile.type != "application/pdf" &&
        briefingFile.type != "text/plain" &&
        briefingFile.type !=
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&
        briefingFile.type !=
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        briefingFile.type != "text/csv"
      ) {
        this.$vs.notify({
          color: "danger",
          title: "Invalid File",
          text:
            "The Briefing Document Must Be A File Of Type: Docx, Doc, Pdf, Xlsx, Xls, Csv, Txt."
        });
        return;
      }
      this.upload_file_name = briefingFile.name;
      let axois_url =
        this.$base_url + "/api/campaigns/document_briefing_upload";
      let formData = new FormData();
      formData.append("file", briefingFile);
      axios
        .post(axois_url, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status == "success") {
            this.campaigns.briefing_document = response.data.data;
          }
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    getPrimaryContacts(inputValue) {
      let data = {};
      data.client_id = this.campaigns.client_id;
      data.search = inputValue;
      return this.$store
        .dispatch("clientUsersManagement/getPrimaryContacts", data)
        .then(res => {
          let result = res.data;
          if (result) {
            let mappedArray = [];
            for (const property in result) {
              mappedArray.push({
                id: result[property].id,
                name:
                  result[property].first_name + " " + result[property].surname
              });
            }
            return mappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllClientContacts(client_id, index) {
      let self = this
      let data = {};
      data.client_id = client_id;
      return self.$store
        .dispatch("clientUsersManagement/getAllClientContacts", data)
        .then(res => {
          let result = res.data;
          self.all_client_contact = result

          self.all_client_contact = self.all_client_contact.filter(item => {
            return item.id != self.campaigns.clients[index].primary_contact_id;
          });

          console.log(self.all_client_contact)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    searchPO(inputValue) {
      return this.$store
        .dispatch("PurchaseOrdersManagement/searchPurchaseOrders", inputValue)
        .then(res => {
          let result = res.data;

          if (result) {
            let POmappedArray = [];
            for (const property in result) {
              POmappedArray.push({
                id: result[property].id,
                name:
                  result[property].po_number,
                remaining_po_value:
                  result[property].remaining_po_value
              });
            }


            var self = this
            const newMappedArray = POmappedArray.filter(({ id: id1 }) => !self.campaigns.purchase_orders.some(({ id: id2 }) => id2 == id1));
            return newMappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    searchCampaignManager(inputValue) {
      let data = {};
      data.role = "Campaign Manager";
      data.search = inputValue;
      return this.$store
        .dispatch("elomarkUsersManagement/getElomarkUsersByRole", data)
        .then(res => {
          let result = res.data;
          if (result) {
            // console.log(data);
            let mappedArray = [];
            for (const property in result) {
              mappedArray.push({
                id: result[property].uuid,
                name:
                  result[property].first_name + " " + result[property].surname
              });
            }
            return mappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllSalesDeveloper() {
      let filter = {};
      filter.user_role = "Sales Developer";
      filter.user_id = this.user_id;
      var self = this;
      return this.$store
        .dispatch("campaignsManagement/getAllSalesDevelopers", filter)
        .then(res => {
          let data = JSON.parse(res.data);
          if (data) {
            let sales = data.filter(function (ele) {
              ele.label = ele.first_name + " " + ele.surname
              ele.value = ele.uuid
              return ele
            })
            self.allSalesDevelopers = data
            console.log(self.allSalesDevelopers)

          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    handleCampaignManager(val) {
      this.campaigns.selected_campaign_manager = val;
    },


    handleSelectedPO(index) {
      const selectedId = modulePurchaseOrdersManagement.state.autocomplete_selected.id;
      // C38 FE-1: a PO may be allocated to a campaign only once (it may still
      // ALSO be that campaign's setup PO — that's the separate field).
      const alreadyUsed = this.campaigns.purchase_orders
        .some((row, i) => i !== index && (row.po_id || row.id) === selectedId);
      if (alreadyUsed) {
        this.$vs.dialog({
          color: 'danger', title: 'Purchase Order', acceptText: 'OK',
          text: 'This purchase order is already allocated to this campaign. '
            + 'Each PO can be used once for the campaign allocation '
            + '(plus once for the setup fee).',
        });
        return;
      }

      this.selected_po_numbers = this.selected_po_numbers.filter(ele => ele.index != index);




      if (this.campaigns.setup_purchase_order_id &&
        this.campaigns.setup_purchase_order_id.id == modulePurchaseOrdersManagement.state.autocomplete_selected.id) {


        this.selected_po_numbers.push({ 'index': index, 'po_number': modulePurchaseOrdersManagement.state.autocomplete_selected })



        if (this.campaigns.setup) {
          this.campaigns.purchase_orders[index].remaining_po_value = parseFloat(modulePurchaseOrdersManagement.state.autocomplete_selected.remaining_po_value) - parseFloat(this.campaigns.setup)
        } else {
          this.campaigns.purchase_orders[index].remaining_po_value = parseFloat(modulePurchaseOrdersManagement.state.autocomplete_selected.remaining_po_value)
        }


        if (this.campaigns.purchase_orders[index].remaining_po_value < 0) {
          this.$vs.dialog({
            accept: this.acceptAlert,

            color: "primary",
            title: `Purchase Order`,
            text:
              "There are not enough funds available on this PO.  Please either reduced the funds allocated to other campaigns OR select a different PO to allocate funds from.",
          });
          this.campaigns.purchase_orders[index].remaining_po_value = parseFloat(modulePurchaseOrdersManagement.state.autocomplete_selected.remaining_po_value)
        }



        this.campaigns.purchase_orders[index].po_id = modulePurchaseOrdersManagement.state.autocomplete_selected.id


      }

      else {
        this.selected_po_numbers.push({ 'index': index, 'po_number': modulePurchaseOrdersManagement.state.autocomplete_selected })
        this.campaigns.purchase_orders[index].remaining_po_value = parseFloat(modulePurchaseOrdersManagement.state.autocomplete_selected.remaining_po_value)
        this.campaigns.purchase_orders[index].po_id = modulePurchaseOrdersManagement.state.autocomplete_selected.id

      }






      console.log(this.selected_po_numbers)



      // this.campaigns.purchase_orders[index].remaining_po_value = modulePurchaseOrdersManagement.state.autocomplete_selected

    },
    handleElomarkUserEvent(val) {
      this.campaigns.user_campaign_association[val].id =
        moduleElomarkUserManagement.state.elomark_user.id;
      this.campaigns.user_campaign_association[val].name =
        moduleElomarkUserManagement.state.elomark_user.first_name + ' ' + moduleElomarkUserManagement.state.elomark_user.surname;
      // this.campaigns.user_campaign_association.push(val);
    },
    handleClientEvent(val) {
      this.campaigns.clients[val].client_id =
        moduleClientManagement.state.searched_clients.id;
      this.campaigns.client_id = this.campaigns.clients[val].client_id;
      this.campaigns.selected_clients.push(val);

      // FIX: Auto-select first client as primary if none selected yet
      if (!this.campaigns.primary_client) {
        this.campaigns.primary_client = this.campaigns.clients[val].client_id;
      }

      // this.companySearchPrimaryContactComponentKey++;
      // this.campaigns.clients[val].primary_contact_id = null;
      this.campaigns.clients[val].other_contact_id = null;
      this.campaigns.clients[val].other_contact_name = null;
    },
    handlePrimaryContacts(index) {
      this.campaigns.clients[index].primary_contact_id =
        moduleClientUserManagement.selected_client_user.id;
    },
    handleOtheClientContacts(index) {
      // this.campaigns.clients[index].other_contact_id.push(moduleClientUserManagement.selected_client_user.id)
    },
    selectPowerBIDashboard() {
      this.selected_client_dashboard = moduleCampaignManagement.state.autocomplete_data
      console.log(this.selected_client_dashboard)
      // this.selectedCommentField = this.selected_comment_field.name
    },
    goBack: function () {
      this.$router.go(-1);
    },
    searchClient(inputValue) {
      return this.$store
        .dispatch("clientsManagement/searchClient", inputValue)
        .then(response => {
          if (response) {
            let data = response.data;
            if (data) {
              let clientMappedArray = [];
              for (const property in data) {
                clientMappedArray.push({
                  id: data[property].id,
                  name: data[property].company_name
                });
              }
              var self = this
              const newMappedArray = clientMappedArray.filter(({ id: id1 }) => !self.campaigns.clients.some(({ client_id: id2 }) => id2 == id1));
              return newMappedArray;
            }
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        });
    },
    submitForm() {
      let self = this



      self.campaigns.sales_developers = self.campaigns.sales_developers.filter(ele => ele.name != null)





      self.selected_po_numbers.forEach(function (ele) {
        self.campaigns.purchase_orders.forEach(function (e, index) {
          if (index == ele.index) {



            if (self.campaigns.setup_purchase_order_id) {
              if (e.id == self.campaigns.setup_purchase_order_id.id) {
                // e.allocated_value = parseFloat(e.allocated_value) + parseFloat(self.campaigns.setup)
                e.allocated_value = parseFloat(e.allocated_value)

              }
            }



            self.campaigns.campaign_po_and_po_allocated_value.push({
              'po_number': ele,
              'po_allocated_value': currency(e.allocated_value)
            })
          }

        })

      })


      console.log(self.campaigns.campaign_po_and_po_allocated_value)
      // return false


      this.errors.clear();
      this.$validator.validateAll().then(result => {


        //         this.campaigns.sales_developers = this.campaigns.sales_developers.filter(ele => ele.name != null)


        // if (this.campaigns.sales_developers.length == 0) {

        //       this.errors.add({
        //         field: "sales_developer",
        //         msg: "Sales Developer field is required"
        //       });
        //       result = false;

        // }

        this.campaigns.sales_developers = this.campaigns.sales_developers.filter(ele => ele.name != null)


        if (!this.campaigns.noSdRequired && this.campaigns.sales_developers.length == 0) {

          this.errors.add({
            field: "sales_developer",
            msg: "Sales Developer field is required"
          });
          result = false;

        }

        if (!this.campaigns.noSdRequired && this.sdAllocationState.hasBlocked) {

          this.errors.add({
            field: "sales_developer",
            msg: "One or more Sales Developer allocations exceed the 10 h/day maximum for their availability — reduce the allocation, extend the window, or free up other commitments."
          });
          result = false;

        }



        this.campaigns.user_campaign_association.forEach(element => {
          if (element.id == null) {
            this.errors.add({
              field: "privileged_elomark_user",
              msg: "Privileged Elomark User field is required"
            });
            result = false;
          }
        });

        this.campaigns.clients.forEach(element => {
          if (element.client_id == null || element.primary_contact_id == null) {
            this.errors.add({
              field: "client",
              msg: "Client and Primary Contact is required"
            });
            result = false;
          }
        });
        if (this.campaigns.selected_campaign_manager == null) {
          this.errors.add({
            field: "campaign_manager",
            msg: "Campaign Manager field is required"
          });
          result = false;
        }
        if (result) {
          if (this.campaigns.selected_campaign_status) {
            this.campaigns.campaign_status = this.campaigns.selected_campaign_status.id;
          }

          if (this.campaigns.selected_campaign_manager) {
            this.campaigns.campaign_manager = this.campaigns.selected_campaign_manager.id;
          }

          if (this.campaigns.start_date) {
            this.campaigns.start_date = moment(
              this.campaigns.start_date
            ).format("YYYY-MM-DD");
          }
          if (this.campaigns.end_date) {
            this.campaigns.end_date = moment(this.campaigns.end_date).format(
              "YYYY-MM-DD"
            );
          }

          this.campaigns.user_campaign_association = this.campaigns.user_campaign_association.filter(
            (v, i, a) => a.findIndex(t => t.id === v.id) === i
          );

          this.campaigns.clients = this.campaigns.clients.filter(
            (v, i, a) => a.findIndex(t => t.client_id === v.client_id) === i
          );

          this.campaigns.user_campaign_association.push(this.campaigns.selected_campaign_manager)



          if (this.campaigns.setup_purchase_order_id) {
            this.campaigns.setup_purchase_order_id = this.campaigns.setup_purchase_order_id.id
          }


this.campaigns.allocation_exempt = !!this.campaigns.allocationExempt;


          // --- SD Time Allocation: merge panel output into the save payload ---
          // Backend keys are snake_case (verified against SDA4: allocated_hours /
          // allocation_note / no_sd_required). Initial allocations default their
          // note to 'Initial allocation' — SDA4 requires a note whenever an
          // allocation is SET or CHANGED (the note is ignored for unchanged rows).
          this.campaigns.no_sd_required = !!this.campaigns.noSdRequired;
          if (!this.campaigns.noSdRequired && !this.campaigns.allocationExempt) {
            let allocs = this.sdAllocationState.allocations;
            this.campaigns.sales_developers.forEach(function (row) {
              let sel = row.name && typeof row.name === "object" ? row.name : null;
              let sd_id = sel ? (sel.uuid || sel.value) : (row.uuid || row.id);
              let match = allocs.find(a => a.salesDeveloperId == sd_id);
              row.allocated_hours = match ? match.allocatedHours : null;
              row.allocation_note = match ? (match.allocationNote || "Initial allocation") : null;
            });
          }
          // -------------------------------------------------------------------



          this.addcampaigns();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    getCampaignStatus() {
      this.$store
        .dispatch("campaignsManagement/getCampaignStatus")
        .then(res => {
          this.campaignStatusList = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getPurchaseOrderList() {
      this.$store
        .dispatch("PurchaseOrdersManagement/fetchPurchaseOrdersList")
        .then(res => {



          this.PurchaseOrderList = res.data


          this.PurchaseOrderList = this.PurchaseOrderList.filter(ele => ele.po_allocation != 'Fully Allocated')

          // console.log('this.PurchaseOrderList', this.PurchaseOrderList)



        })
        .catch(err => {
          console.error(err);
        });
    },
    addcampaigns() {

      this.$store
        .dispatch("campaignsManagement/addCampaign", this.campaigns)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Campaign Added",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Campaign Added",
              text: "The campaign was added successfully"
            });
            this.$router.push({ path: "/campaigns" });
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}

.pagination {
  display: inline-block;
}

[dir=ltr] .vs__dropdown-menu {
  max-height: 200px;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  border: 1px solid #ddd;
  /* Gray */
}
</style>
